import { motion } from 'framer-motion';

export default function FeaturedCampaigns() {
  const benefits = [
    {
      number: '01',
      title: 'Accelerated Depreciation',
      description: 'Under US tax law, billboard assets can be 100% depreciated over 4 years, delivering significant tax benefits.',
    },
    {
      number: '02',
      title: 'Advertising Revenue Model',
      description: 'Generate stable advertising income by leasing your owned billboards to third parties. Average annual yield: 12-18%.',
    },
    {
      number: '03',
      title: 'Optimized Cash Flow',
      description: 'Average payback period is 18-24 months. After that, generate continuous cash flow as net profit.',
    },
  ];

  return (
    <section className="relative py-20 px-6 bg-gradient-to-br from-navy-900 via-navy-800 to-navy-900 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="w-full h-full" style={{
          backgroundImage: 'radial-gradient(circle, #FFD700 1px, transparent 1px)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      {/* Background Image */}
      <div className="absolute right-0 top-1/2 -translate-y-1/2 w-1/2 h-full opacity-80">
        <img
          src="https://static.readdy.ai/image/054669bfa6c90ed6f4fe30e8050dd867/c343fd3933a1b08d795f370adf77b8bf.jpeg"
          alt="Billboard Investment"
          className="w-full h-full object-contain object-center"
        />
      </div>

      <div className="relative max-w-6xl mx-auto">
        <div className="max-w-2xl">
          {/* Badge */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="inline-block mb-8"
          >
            <span className="px-6 py-2 rounded-md border-2 border-neon-gold text-neon-gold text-xs font-semibold uppercase tracking-wider">
              Investment Benefits
            </span>
          </motion.div>

          {/* Title */}
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-16 leading-tight"
          >
            3 Key Benefits of<br />
            Billboard Investment
          </motion.h2>

          {/* Benefits List */}
          <div className="space-y-10">
            {benefits.map((benefit, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.2 + index * 0.1 }}
                className="flex gap-6 group"
              >
                {/* Number Badge */}
                <div className="flex-shrink-0">
                  <div className="w-16 h-16 rounded-full bg-neon-gold flex items-center justify-center">
                    <span className="text-2xl font-bold text-navy-900">{benefit.number}</span>
                  </div>
                </div>

                {/* Content */}
                <div className="flex-1 pt-2">
                  <h3 className="text-2xl font-bold text-white mb-3 group-hover:text-neon-gold transition-colors">
                    {benefit.title}
                  </h3>
                  <p className="text-gray-300 text-base leading-relaxed">
                    {benefit.description}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
